import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaArrowLeft } from 'react-icons/fa';
import passwordService from '../../services/passwordService';
import './LoginPage.css';

export default function ForgotPasswordPage() {
  const navigate          = useNavigate();
  const [email, setEmail] = useState('');
  const [mensaje, setMensaje] = useState(null);
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setMensaje(null);
    try {
      const res = await passwordService.enviarCorreo(email);
      setMensaje({ tipo: 'success', texto: res.message });
    } catch {
      setMensaje({ tipo: 'danger', texto: 'Error al enviar el correo.' });
    } finally {
      setCargando(false);
    }
  };

  return (
    <main className="login-wrapper">
      <div className="login-card">

        {/* Ícono */}
        <div className="login-icon">
          <FaEnvelope />
        </div>

        <h2 className="login-title">Recuperar contraseña</h2>
        <p className="login-subtitle">
          Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña
        </p>

        {mensaje && (
          <div className={`alert alert-${mensaje.tipo} text-center small mb-3`}>
            {mensaje.texto}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-3">
            <label className="login-label">
              <FaEnvelope className="me-2" />
              Correo electrónico
            </label>
            <input
              type="email"
              className="input-custom"
              placeholder="tucorreo@ejemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn-primary-custom mb-3"
            disabled={cargando}
          >
            {cargando ? 'Enviando...' : 'Enviar enlace de recuperación'}
          </button>
        </form>

        <div className="text-center">
          <button
            className="btn btn-link text-muted small"
            onClick={() => navigate('/login')}
          >
            <FaArrowLeft className="me-1" /> Volver al login
          </button>
        </div>

      </div>
    </main>
  );
}